/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { styled } from '@mui/system';
import Switch, { SwitchProps } from '@mui/material/Switch';
import Stack from '@mui/material/Stack';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import PropTypes from 'prop-types';

import {
    Container, Divider, Box, Typography, List, ListItem, ListItemText, ListItemButton,
} from '@mui/material';

import Filters from '../Filters';

const SideBarWrapper = styled(Box, {})(({ theme }) => ({
    backgroundColor: '#FFFFFF',
    width: '250px',
    position: 'fixed',
    top: 0,
    left: 0,
    height: '100%',
    overflow: 'auto',
    padding: '80px 10px 10px 10px',
    boxShadow: '-1px 0px 10px 2px rgb(0 0 0 / 15%)',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    gap: 50,
    // backgroundImage: 'url("assets/images/Art_CubesConnections.png")',
    // backgroundRepeat: 'no-repeat',
    // backgroundSize: 'contain',
    // backgroundPosition: 'center bottom',
    '.poweredaws': {
        // bottom: '50px',
        textAlign: 'center',
    },
    '.poweredaws img': {
        width: '120px',
    },
}));

const MaterialUISwitch = styled(Switch)(({ theme }) => ({
    width: 62,
    height: 34,
    padding: 7,
    margin: '10px 0 !important',
    '& .MuiSwitch-switchBase': {
        margin: 1,
        padding: 0,
        transform: 'translateX(6px)',
        '&.Mui-checked': {
            color: '#fff',
            transform: 'translateX(22px)',
            '& .MuiSwitch-thumb:before': {
                backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 394.4 394.4"><path fill="${encodeURIComponent(
                    '#fff',
                )}" d="M37.4 377.4c-5.223 0-10.438-1.992-14.423-5.977-7.97-7.963-7.97-20.883 0-28.846l319.6-319.601c7.97-7.97 20.876-7.97 28.846 0 7.97 7.962 7.97 20.882 0 28.845l-319.6 319.601c-3.985 3.986-9.2 5.978-14.423 5.978zm357-78.201c0-52.496-42.704-95.199-95.2-95.199S204 246.703 204 299.199s42.704 95.201 95.2 95.201 95.2-42.705 95.2-95.201zm-40.799 0c0 29.996-24.405 54.4-54.4 54.4s-54.4-24.404-54.4-54.4c0-29.994 24.405-54.398 54.4-54.398s54.4 24.404 54.4 54.398zM190.4 95.2C190.4 42.704 147.696 0 95.2 0S0 42.704 0 95.2s42.704 95.2 95.2 95.2 95.2-42.704 95.2-95.2zm-40.8 0c0 29.995-24.405 54.4-54.4 54.4s-54.4-24.405-54.4-54.4 24.405-54.4 54.4-54.4 54.4 24.406 54.4 54.4z"/></svg>')`,
            },
            '& + .MuiSwitch-track': {
                opacity: 1,
                backgroundColor: theme.palette.mode === 'dark' ? '#8796A5' : '#aab4be',
            },
        },
    },
    '& .MuiSwitch-thumb': {
        backgroundColor: theme.palette.mode === 'dark' ? '#003892' : '#001e3c',
        width: 32,
        height: 32,
        '&:before': {
            content: "''",
            position: 'absolute',
            width: '14px',
            height: '14px',
            left: 'calc(50% - 7px)',
            top: 'calc(50% - 7px)',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024"><path fill="${encodeURIComponent(
                '#fff',
            )}" d="M872 394c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8H708V152c0-4.4-3.6-8-8-8h-64c-4.4 0-8 3.6-8 8v166H400V152c0-4.4-3.6-8-8-8h-64c-4.4 0-8 3.6-8 8v166H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h168v236H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h168v166c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8V706h228v166c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8V706h164c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8H708V394h164zM628 630H400V394h228v236z"/></svg>')`,
        },
    },
    '& .MuiSwitch-track': {
        opacity: 1,
        backgroundColor: theme.palette.mode === 'dark' ? '#8796A5' : '#aab4be',
        borderRadius: 20 / 2,
    },
}));

const SideBar = ({
    groups, onGroupClick, selectedGroup, percentageChecked, setPercengeChecked,
}) => {
    const handleChange = (event) => {
        setPercengeChecked(event.target.checked);
    };

    return (

        <SideBarWrapper>
            <Box>
                <nav aria-label="main mailbox folders">
                    <List>
                        {groups.map((group, index) => (
                            <Box key={group}>
                                <ListItem disablePadding key={group}>
                                    <ListItemButton
                                      onClick={() => onGroupClick(group)}
                                      sx={{
                                            background: group === selectedGroup ? '#009845' : '#f9f9f9',
                                            '&:hover': {
                                                background: group === selectedGroup ? '#009845' : '#ebebeb',
                                            },
                                        }}
                                    >
                                        <Typography
                                          sx={{
                                                color: group === selectedGroup ? '#FFFFFF' : '#54565A',
                                            }}
                                        >
                                            {group}
                                        </Typography>
                                    </ListItemButton>
                                </ListItem>
                                {index !== groups.length - 1 && <Divider light />}
                            </Box>
                        ))}
                    </List>
                </nav>
                <Divider sx={{ margin: '10px 0' }} />
                <Filters />
                <Divider sx={{ margin: '10px 0' }} />
                <Box>
                    <Typography variant="body2" sx={{ fontWeight: 'bold' }}>CHANGE MEASURE:</Typography>
                </Box>
                <FormGroup>
                    <Stack direction="row" spacing={1} alignItems="center">
                        <Typography># of Resp.</Typography>
                        <FormControlLabel
                          control={<MaterialUISwitch sx={{ m: 1 }} checked={percentageChecked} onChange={handleChange} />}
                        />
                        <Typography>% of Resp.</Typography>
                    </Stack>
                </FormGroup>
            </Box>
            <a href="https://aws.amazon.com/what-is-cloud-computing" className="poweredaws">
                <img src="assets/images/Powered-By_logo-stack_RGB.png" alt="Powered by AWS Cloud Computing" />
            </a>
        </SideBarWrapper>

    );
};

SideBar.propTypes = {
    groups: PropTypes.array,
    selectedGroup: PropTypes.string,
    onGroupClick: PropTypes.func,
    percentageChecked: PropTypes.bool,
    setPercengeChecked: PropTypes.func,
};

SideBar.defaultProps = {
    groups: [],
    selectedGroup: '',
    onGroupClick: () => { },
    percentageChecked: true,
    setPercengeChecked: () => { },
};

export default SideBar;
